import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FetchDataService {
  baseURL = '../../../assets/content/';
  constructor(private http: HttpClient) {}

  getContentData(lang: string, filename: string): Observable<any> {
    return this.http.get<any[]>(this.baseURL + lang + '/' + filename + '.json');
  }
}
